module.exports = __webpack_public_path__ + "static/media/suitcase-rolling.8835368c.svg";